module.exports = __webpack_public_path__ + "img/pr-3.4de2ee45.png";